import { TutorialStep } from "..";

export const InspStatusModalSteps: TutorialStep[] = [
  {
    // 추후 리뷰를 제일 마지막 소개하고 threhold, 히트맵 등을 먼저 안내
    target: "#status-review",
    content: `리뷰 버튼을 클릭하여 이미지에 대한 리뷰를 진행할 수 있습니다.`,
    spotlightClicks: false,
    hideFooter: false,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#status-review",
    content: `NG 5장 review를 해봅시다.\n 키보드의 화살표(위/아래)를 이용하여 이미지를 이동할 수 있습니다.`,
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    nextTrigger: "#make-dataset-btn",
    disableOverlayClose: true,
  },
  {
    target: "#make-dataset-btn",
    content: `리뷰를 완료한 후, Make Dataset 버튼을 클릭하여 데이터셋을 생성할 수 있습니다.`,
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    disableOverlayClose: true,
  },
];
